import { DocumentFileType, FileExtensionTypeMap } from "../type";

export const getUploadFileType = (file: File) => {

    console.log("file", file);
    if (file.type.includes("document")) {
        return DocumentFileType.WORD
    }
    if (file.type.includes("sheet")) {
        return DocumentFileType.EXCEL
    }
    return DocumentFileType.WORD
}

export const getFileSuffixByType = (type: DocumentFileType) => {
    if (type === DocumentFileType.WORD) {
        return ".docx"
    }
    if (type === DocumentFileType.EXCEL) {
        return ".xlsx"
    }
    return '.docx'
}
// 定义支持预览的文件扩展名列表
export const PREVIEW_FILE_EXTENSIONS = [
    'xlsx', // Excel文件
    'xls',  // Excel文件(旧版)
    'doc',  // Word文件(旧版)
    'docx', // Word文件
    'txt',  // 文本文件
    'md',   // Markdown文件
    'pdf',   // PDF文件
    // 'jpg',   // 图片文件
    // 'png'   // 图片文件
] as const;

// 定义支持上传的文件扩展名列表
export const UPLOAD_FILE_EXTENSIONS = [
    'xlsx', // Excel文件
    'xls',  // Excel文件(旧版)
    'doc',  // Word文件(旧版)
    'docx', // Word文件
    'txt',  // 文本文件
    'md',   // Markdown文件
    'pdf',   // PDF文件
    'jpg',   // 图片文件
    'png',  // 图片文件
    'dwg'
] as const;

/**
 * 判断文件是否可以预览
 * @description 支持以下文件类型：
 * - Office文档：xlsx、xls、doc、docx
 * - 文本文件：txt、md
 * - PDF文件：pdf
 * @param fileName - 文件名
 * @returns {boolean} 如果文件类型支持预览返回true，否则返回false
 * @example
 * isLegalPreviewFileType('document.docx') // true
 * isLegalPreviewFileType('image.png') // false
 * isLegalPreviewFileType('') // false
 */
export const isLegalPreviewFileType = (fileName: string): boolean => {
    if (!fileName) return false;


    // 获取文件扩展名并转换为小写
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    if (!fileExtension) return false;

    // 检查文件扩展名是否在支持列表中
    return PREVIEW_FILE_EXTENSIONS.includes(fileExtension as typeof PREVIEW_FILE_EXTENSIONS[number]);
}


export const isLegalUploadFileType = (fileName: string): boolean => {
    if (!fileName) return false;
    // 获取文件扩展名并转换为小写
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    if (!fileExtension) return false;

    // 检查文件扩展名是否在支持列表中
    return UPLOAD_FILE_EXTENSIONS.includes(fileExtension as typeof PREVIEW_FILE_EXTENSIONS[number]);
}

// 判断文件类型是否展示域配置
export const isShowDomainConfigByFileName = (fileName: string) => {
    const fileExtension = fileName.split(".").pop()
    console.log("fileExtension", fileExtension, [DocumentFileType.WORD,].includes(FileExtensionTypeMap[fileExtension]))
    return (
        [DocumentFileType.WORD,].includes(FileExtensionTypeMap[fileExtension])
    );
}

// // 根据文档的其他属性判断是否展示域配置
// export const isShowDomainConfigByFileAttr = (file: any) => {
//     // 卷不展示域配置
//     if (file.isJuan) {
//         return false
//     }
//     return true
// }